import { lazy } from 'react';

export default {
  auth: { type: 'public' },
  path: 'login',
  title: 'Login',
  component: lazy(() => import('Modules/login')),
};
